import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: '重定向首页', redirect: '/nav' },
    { path: '/nav', name: '添加nav', component: () => import('@/views/NavContainer.vue'), redirect: '/index', children: [
        { path: '/index', name: '首页', meta: { title: '我的课程' }, component: () => import('@/views/Home.vue') },
        { path: '/menu', name: '首页底部按钮', component: () => import('@/views/MenuSelect.vue'), redirect: '/index' , children: [
            { path: '/about', name: 'about', component: () => import('@/views/About.vue') },
          ]
        },
        { path: '/classRecord', name: '学习档案', meta: { title: '学习档案' }, component: () => import('@/views/ClassRecord.vue')},
        { path: '/classDetail', name: '课程详情', meta: { title: '课程详情' }, component: () => import('@/views/ClassDetail.vue')},
				{ path: '/exercise', name: '练习题', meta: { title: '练习题' }, component: () => import('@/views/Exercise.vue')},
				{ path: '/errBook', name: '错题练习', meta: { title: '错题练习' }, component: () => import('@/views/ErrorBook.vue')},
        { path: '/exam', name: '结课考试', meta: { title: '结课考试' }, component: () => import('@/views/ExamPage.vue')},
        { path: '/examView', name: '查看考试', meta: { title: '查看考试' }, component: () => import('@/views/ExamView.vue')},
        { path: '/class', name: '视频页面', meta: { title: '视频页面' }, component: () => import('@/views/ClassVideo.vue'), redirect: '/class/list', children: [
            { path: '/class/list', name: '课程目录', meta: { title: '课程目录' }, component: () => import('@/views/class/ClassList.vue')},
            { path: '/class/desc', name: '课程介绍' , component: () => import('@/views/class/ClassDesc.vue')},
            { path: '/class/interact', name: '学员互动' , component: () => import('@/views/class/ClassInteract.vue')},
          ]
        },
        { path: '/studyLogs', name: '学时查询', meta: { title: '学时查询' }, component: () => import('@/views/StudyLogs.vue') },
        { path: '/classArticles', name: '阅读模块文章列表', meta: { title: '阅读' }, component: () => import('@/views/ClassArticles.vue') },
        { path: '/articleList', name: '文章列表', component: () => import('@/views/Articles.vue') },
        { path: '/articleDetail', name: '文章详情', component: () => import('@/views/ArticleDetail.vue') },
        { path: '/recogpc', name: '人脸识别', meta: { title: '人脸识别' }, component: () => import('@/views/RecognitionForPC.vue') },
      ]},
    { path: '/test', name: 'test', component: () => import('@/views/PageTest.vue') },
    { path: '/login', name: '登录页面', meta: { title: '登录' }, component: () => import('@/views/Login.vue') },
    { path: '/loginFailed', name: '登录失败页面', meta: { title: '登录失败' }, component: () => import('@/views/LoginFailed.vue') },
    { path: '/user_agreement', name: '用户协议', meta: { title: '用户协议' }, component: () => import('@/views/about/UserAgreement.vue') },
    { path: '/privacy_policy', name: '隐私政策', meta: { title: '隐私政策' }, component: () => import('@/views/about/PrivacyPolicy.vue') },
    { path: '/recog', name: '人脸识别', meta: { title: '人脸识别' }, component: () => import('@/views/RecognitionForPC.vue') },
		{ path: '*', redirect: '/index' },
  ]
})
